import { useContext } from "react";
import { ThemeValues } from "../ThemeUsage/theme";
import Start from "src/pages/SiteAuthentication/Start";
import { ThemeContext } from "../ThemeUsage/ThemeUsage";
import Failed from "src/pages/SiteAuthentication/Failed";
import Success from "src/pages/SiteAuthentication/Success";
import { SITE_AUTHENTICATION_PATHS } from "src/consts/paths";
import { Route, Routes, useLocation } from "react-router-dom";
import { SITE_AUTHENTICATION_ROUTES } from "src/consts/routes";
import { Container, Grid, Stack, useTheme } from "@mui/material";
import SiteAuthenticationFooter from "../Footer/SiteAuthenticationFooter";
import SiteAuthenticationProgressBar from "../SiteAuthenticationProgressBar";
import AuthenticationCallback from "src/pages/SiteAuthentication/AuthenticationCallback";

const SiteAuthentication = () => {
  const theme = useTheme();
  const { pathname } = useLocation();
  const themeName = useContext(ThemeContext);
  const isUserSelectEnabled = themeName !== ThemeValues.lichtblick;

  return (
    <Stack
      sx={{
        minHeight: "100vh",
        background: theme.palette.background.default,
        userSelect: isUserSelectEnabled ? undefined : "none",
      }}
    >
      <Container
        sx={{
          px: 4,
          flexGrow: 1,
          marginTop: { xs: 0, sm: 12 },
        }}
      >
        <Grid container>
          <Grid item xs={12} sm={4}>
            {SITE_AUTHENTICATION_PATHS.includes(pathname) && (
              <SiteAuthenticationProgressBar />
            )}
          </Grid>

          <Stack
            sx={{
              display: { xs: "flex", sm: "none" },
              justifyContent: "center",
              width: "100%",
              py: 2,
            }}
          ></Stack>

          <Grid item xs={12} sm={8} sx={{ paddingLeft: { sm: 5, md: 20 } }}>
            <Routes>
              <Route
                element={<Start />}
                path={SITE_AUTHENTICATION_ROUTES.START}
              />
              <Route
                element={<Success />}
                path={SITE_AUTHENTICATION_ROUTES.SUCCESS}
              />
              <Route
                element={<Failed />}
                path={SITE_AUTHENTICATION_ROUTES.FAILED}
              />
              <Route
                element={<AuthenticationCallback />}
                path={SITE_AUTHENTICATION_ROUTES.AUTHENTICATION_CALLBACK}
              />
            </Routes>
          </Grid>
        </Grid>
      </Container>
      <SiteAuthenticationFooter />
    </Stack>
  );
};

export default SiteAuthentication;
